import { render, staticRenderFns } from "./WaitTimeForm.vue?vue&type=template&id=6b933a5f"
import script from "./WaitTimeForm.vue?vue&type=script&lang=js"
export * from "./WaitTimeForm.vue?vue&type=script&lang=js"
import style0 from "./WaitTimeForm.vue?vue&type=style&index=0&id=6b933a5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports